<template>
    <div class="my-panel">
        <div class="my-panel__hd">
            <h3>获取草根值方式1</h3>
        </div>
        <div class="my-panel__bd panel_style ta-center">
            <div v-if="hxExp">
                <p class="text-tip">若您购买过和讯合作商品，验证和讯账号可得到草根值</p>
                <p><van-icon name="passed" color="#ffffff" size="0.4rem"></van-icon>和讯账号已验证，共得到{{hxExp.toFixed(2)}}草根值</p>
                <br>
                <a :href="hxUrl" class="btn-yellow btn-round">查看详情</a>
            </div>            
            <div v-else>
                <k-hr size="50"></k-hr>
                <p class="text-tip">若您购买过和讯合作商品，验证和讯账号可得到草根值</p>
                <br>
                <a :href="hxUrl" class="btn-yellow btn-round">前往领取</a>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState,mapActions} from 'vuex'
    import {HOST_WEB} from '../../../const'
    export default {
        data() {
            return {
                hxExp : 0,
                //hxUrl : 'https://'+ HOST_WEB + '/award/hxlesson?redirectUrl=https://iwangzhe.com'
            }
        },
        computed: {
            ...mapState('exp',['isHexun']),
            ...mapState('config', ['wzConfig']),
            hxUrl(){
                return this.wzConfig?this.wzConfig.hxUrl : ''
            }
        },
        methods: {
            ...mapActions('exp', ['hxInfo','sourceExp']),
        },
        async created() {
            //const R = await this.hxInfo()
            await this.sourceExp({
                sources : '4,14,15'
            }).then(R=>{
                this.hxExp = R.expSum/100
            })
        },
    }
</script>